import React from 'react';
import MineClassLogo from '../assets/MineClass.png';
import UnbiaxLogo from '../assets/unbiax13.png';
import CajaArequipaLogo from '../assets/Caja-Arequipa.png';
import BateasLogo from '../assets/bateas.jpg';
import CCPChLogo from '../assets/CCPCh.png';


const Allies = React.forwardRef((props, ref) => {
  return (
    <section ref={ref} id="aliados" className="py-20 bg-white">
      <div className="max-w-[104rem] mx-auto px-4">

        {/* Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-800 mb-6">
            Nuestros <span className="text-fhk-cyan-600">Partners</span>
          </h2>
          <div className="w-24 h-1 bg-fhk-orange-500 mx-auto rounded-full mb-8"></div>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Trabajamos juntos a colegios, empresas y organizaciones
          </p>
        </div>

        <div className="bg-gray-50 rounded-3xl p-8 md:p-12 mb-16">
       

          {/* GRID DE PARTNERS */}
          <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-5 gap-8 max-w-[104rem] mx-auto">

            {/* Unbiax */}
            <div className="bg-white rounded-3xl p-8 shadow-xl text-center">
              <div className="flex justify-center mb-6 h-24">
                <img src={UnbiaxLogo} alt="Unbiax" className="max-h-full object-contain" />
              </div>
              <h4 className="font-bold text-gray-800 text-xl mb-2">Unbiax</h4>
              <p className="text-fhk-cyan-600 font-semibold mb-4">
                Ecosistema de cumplimiento y riesgos
              </p>

              <div className="text-gray-600 text-sm space-y-2">
                <p>Plataforma que integra compliance, riesgos e IA.</p>
                <p>Centraliza datos y procesos de negocio.</p>
                <p>Permite trazabilidad y auditoría completa.</p>
                <p>Escalable e integrable con sistemas existentes.</p>
              </div>
            </div>

            {/* MineClass */}
            <div className="bg-white rounded-3xl p-8 shadow-xl text-center">
              <div className="flex justify-center mb-6 h-24">
                <img src={MineClassLogo} alt="MineClass" className="max-h-full object-contain" />
              </div>
              <h4 className="font-bold text-gray-800 text-xl mb-2">MineClass</h4>
              <p className="text-fhk-cyan-600 font-semibold mb-4">
                Capacitación digital minera
              </p>

              <div className="text-gray-600 text-sm space-y-2">
                <p>OTEC digital especializada en minería.</p>
                <p>Formación online disponible 24/7.</p>
                <p>Metodología eficiente sin logística.</p>
                <p>Certificación bajo norma NCh2728.</p>
              </div>
            </div>

            {/* Caja Arequipa */}
            <div className="bg-white rounded-3xl p-8 shadow-xl text-center">
              <div className="flex justify-center mb-6 h-24">
                <img src={CajaArequipaLogo} alt="Caja Arequipa" className="max-h-full object-contain" />
              </div>
              <h4 className="font-bold text-gray-800 text-xl mb-2">Caja Arequipa</h4>
              <p className="text-fhk-cyan-600 font-semibold mb-4">
                Inclusión financiera
              </p>

              <div className="text-gray-600 text-sm space-y-2">
                <p>Líder en microfinanzas en Perú.</p>
                <p>Apoya a emprendedores y pymes.</p>
                <p>Fomenta inclusión financiera.</p>
                <p>Impulsa desarrollo económico sostenible.</p>
              </div>
            </div>

            {/* Minera Bateas */}
            <div className="bg-white rounded-3xl p-8 shadow-xl text-center">
              <div className="flex justify-center mb-6 h-24">
                <img src={BateasLogo} alt="Minera Bateas" className="max-h-full object-contain" />
              </div>
              <h4 className="font-bold text-gray-800 text-xl mb-2">Minera Bateas</h4>
              <p className="text-fhk-cyan-600 font-semibold mb-4">
                Minería responsable
              </p>

              <div className="text-gray-600 text-sm space-y-2">
                <p>Operación minera con altos estándares.</p>
                <p>Foco en seguridad y sostenibilidad.</p>
                <p>Procesos eficientes y responsables.</p>
                <p>Impacto positivo en su entorno.</p>
              </div>
            </div>

            {/* Cámara de Comercio Peruano-Chilena */}
            <div className="bg-white rounded-3xl p-8 shadow-xl text-center">
              <div className="flex justify-center mb-6 h-24">
                <img src={CCPChLogo} alt="Cámara de Comercio Peruano-Chilena" className="h-full w-auto object-contain scale-[1.3]" />
              </div>
              <h4 className="font-bold text-gray-800 text-xl mb-2">Cámara de Comercio Peruano-Chilena</h4>
              <p className="text-fhk-cyan-600 font-semibold mb-4">
                Referente binacional
              </p>

              <div className="text-gray-600 text-sm space-y-2">
                <p>Institución que fortalece la relación comercial entre Perú y Chile.</p>
                <p>Promueve redes de colaboración entre empresas y organizaciones.</p>
                <p>Impulsa iniciativas de integración y desarrollo económico binacional.</p>
              </div>
            </div>

          </div>
        </div>
      </div>
    </section>
  );
});

Allies.displayName = 'Allies';

export default Allies;